import type { Patient } from '../types/Patient'
import { useAuth } from '../contexts/AuthProvider'

const useRanOutOfBulkSessions = () => {
  const { user } = useAuth()

  return user.roster.some((p: Patient) =>
    p?.carePlans.some(
      (cp) =>
        !cp.isIep &&
        cp?.bulkModel?.isBulkModel &&
        !cp?.bulkModel?.remainingSessionsOnBulkModel
    )
  )
}

export default useRanOutOfBulkSessions
